import i18instance from "i18instance";

export const TEAM_NAME_IS_REQUIRED = i18instance.t("errors:TEAM_NAME_IS_REQUIRED");
export const TEAM_NAME_BAD_WORDS = i18instance.t("errors:TEAM_NAME_BAD_WORDS");
export const TEAM_NAME_ONLY_LATIN_OR_DIGITS = i18instance.t("errors:TEAM_NAME_ONLY_LATIN_OR_DIGITS");
export const TEAM_NAME_SHOULD_BE_LESS_31 = i18instance.t("errors:TEAM_NAME_SHOULD_BE_LESS_31");